import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Calculator } from '@ratehub/base-ui';
import CALCULATOR_WIDTHS from '../definitions/CalculatorWidths';
import ContributionLimitRRSPCalcInputStep from './ContributionLimitRRSPCalcInputStep';


function ContributionLimitRRSPCalculator({ ...otherProps }) {
    return (
        <StyledCalculator
            title={(
                <FormattedMessage
                    id="calculator.ContributionLimitRRSPCalculator.calculatorTitle"
                    defaultMessage="Ratehub.ca’s RRSP contribution room calculator"
                />
            )}
            {...otherProps}
        >
            <ContributionLimitRRSPCalcInputStep {...otherProps} />
        </StyledCalculator>
    );
}

const StyledCalculator = styled(Calculator)`
    max-width: ${CALCULATOR_WIDTHS.SMALL};
`;

export default observer(ContributionLimitRRSPCalculator);